var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.catalogComponent)?_c(_setup.catalogComponent,{key:_setup.componentKey,ref:"component",tag:"component",attrs:{"catalog-info":_vm.catalogInfo,"section-info":_vm.sectionInfo,"thumbnail-info":_setup.thumbnailInfo,"multisection-index":_vm.multisectionIndex}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }